module.exports = __webpack_public_path__ + "static/media/profile_photo.767a25c7.png";